import { z } from 'zod';

export const WordingsDTO = z.object({
    wordings: z
        .array(
            z.object({
                key: z.string(),
                value: z.string().optional(),
            }),
        )
        .default([]),
});

export type WordingsDTO = z.infer<typeof WordingsDTO>;
